import React from "react";
import axios from "axios";
import { getBackend } from "../../../utils/getBackend";
import { getAccessTokenHeader } from "../../../api/helper/getAccessTokenHeader";
import { handleError } from "../../../utils/handleError";

interface SocialAuthProps {
  platform: "meta" | "threads" | "bluesky" | "mastodon";
  title: string;
  showRefreshButton?: boolean;
  instanceUrl?: string;
  postAs?: string;
}

export const SocialAuth: React.FC<SocialAuthProps> = ({
  platform,
  title,
  showRefreshButton = false,
  instanceUrl,
  postAs,
}) => {
  const [loading, setLoading] = React.useState(false);

  const handleLogin = async () => {
    setLoading(true);
    const requestBody = instanceUrl ? { instance_url: instanceUrl } : {};

    try {
      const {
        data: { redirect },
      } = await axios.post(
        getBackend() + `/${platform}/auth/login`,
        { ...requestBody, feed_slug: postAs },
        { headers: await getAccessTokenHeader() }
      );

      window.location = redirect;
    } catch (error) {
      console.error("Error during login:", error);
      handleError(error as Error);
    } finally {
      setLoading(false);
    }
  };

  const refreshIds = async () => {
    // Determine the correct endpoint based on the platform
    let endpoint = "/" + platform + "/app-ids/refresh";
    if (platform === "bluesky") {
      endpoint = "/" + platform + "/auth/refresh";
    }

    const { data } = await axios.post(getBackend() + endpoint, null, {
      headers: await getAccessTokenHeader(),
    });
    console.log("IDs refreshed", data);
  };

  return (
    <fieldset className="fieldset bg-base-200 border-base-300 rounded-box border p-4">
      <legend className="fieldset-legend">{title} Auto-Publish Tokens</legend>

      <div className="flex gap-4">
        <button
          type="button"
          onClick={handleLogin}
          className="btn btn-primary gap-2"
        >
          {loading && <span className="loading loading-spinner loading-sm" />}
          Get {title} Access Token
        </button>

        {showRefreshButton && (
          <button
            type="button"
            onClick={refreshIds}
            className="btn btn-neutral"
          >
            {platform === "bluesky" ? "Refresh Tokens" : "Refresh Account IDs"}
          </button>
        )}
      </div>

      <p className="label">
        {platform === "bluesky"
          ? `Use this option to automatically get long-lived tokens to auto publish to ${title}.`
          : `Use this option to automatically get tokens to auto publish to ${title}.`}
      </p>
    </fieldset>
  );
};
